import { Component, OnInit, Input } from '@angular/core';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { AccountAssessment } from '../../../models/AssessmentModel';
import { AssessmentService } from '../../../services/assessment.service';

@Component({
  selector: 'app-section-radar',
  templateUrl: './section-radar.component.html'
})
export class SectionRadarComponent implements OnInit {

  @Input()
  set assessment(assessment: AccountAssessment) {
    this._assessment = assessment;

    if (this._assessment) {
      this.lineChartData = [];
      this.lineChartColors = [];
      Object.keys(this._assessment.scoredResultsJson.nistFunctions).forEach(nistFunctionKey => {
        const nistFunction = this._assessment.scoredResultsJson.nistFunctions[nistFunctionKey];
        this.lineChartData.push({
          label: nistFunction.name,
          data: [{
            x: nistFunction.score,
            y: nistFunction.impact,
          }]
        });
        const rgbColor = this._assessmentService.getNistFunctionColor(nistFunctionKey).rgb;
        this.lineChartColors.push({
          backgroundColor: `rgba(${rgbColor}, 0.6)`,
          borderColor: `rgba(0, 0, 0, 0.5)`,
          // pointBackgroundColor: `rgba(${rgbColor}, 0.6)`,
          // pointBorderColor: `rgba(0, 0, 0, 0.5)`,
          // pointHoverBackgroundColor: `rgba(${rgbColor}, 0.6)`,
          // pointHoverBorderColor: `rgba(0, 0, 0, 0.5)`,
          pointRadius: 8,
          pointHoverRadius: 12
        });
      });
      console.log(this.lineChartColors);
    }

  }

  get assessment(): AccountAssessment { return this._assessment; }

// x - probability
// y - impact
  constructor(private _assessmentService: AssessmentService) { }
  _assessment: AccountAssessment;
  selectNistCategory: any;

  // Radar
  public radarChartLabels:string[] = ['Identify', 'Protect', 'Detect', 'Respond', 'Recover'];

  public radarChartData:any = [
    {data: [65, 59, 90, 81, 56], label: 'Series A'}
  ];
  public radarChartType = 'radar';

  public lineChartData:Array<any> = [];
  public chartOptions:any = {
    responsive: true,
    scale: {
        // Hides the scale
        display: true,
        ticks: {
          min: 0,
          max: 100
        }
    },
    tooltips: {
      displayColors: false,
      callbacks: {
        title(tooltipItem, data) {
          return data.datasets[tooltipItem[0].datasetIndex].label;
        },
        label: this.getTooltipLabel
      }
   }
  };
  public lineChartColors:Array<any> = [];
  public lineChartLegend = false;
  public lineChartType = 'scatter';

  ngOnInit() {
  }

  public getTooltipLabel(tooltipItem, data) {
    const avg = (data.datasets[tooltipItem.datasetIndex].data[0].x + data.datasets[tooltipItem.datasetIndex].data[0].y)/2;
    const lvl = Math.floor(avg / 10);
    let risk = 'Low';
    if (lvl <= 3) {
      risk = 'High';
    } else if (lvl <= 6) {
      risk = 'Medium';
    }
    return ['Probability: ' + tooltipItem.xLabel, 'Impact: ' + tooltipItem.yLabel, 'Risk: ' + risk];
  }

  // events
  public chartClicked(e:any):void {
    console.log(e);
    // if (e.active.length>0) {
    //   this.selectedCategory = this.lineChartData[e.active[0]._datasetIndex].label;
    //   console.log(this.selectedCategory);
    // }
  }

  public chartHovered(e:any):void {
    console.log(e);
  }

  private getRiskLabel(val) {
    const lvl = Math.floor(val / 10);
    if (lvl <= 3) {
      return 'High';
    } else if (lvl <= 6) {
      return 'Medium';
    } else {
      return 'Low';
    }
  }

  getSelectedQuestions() {
    return Object.keys(this.assessment.scoredResultsJson.riskSubSections[this.selectNistCategory].questions).map(questionLabel => {
      const q = {
        label: questionLabel,
        value: this.assessment.scoredResultsJson.riskSubSections[this.selectNistCategory].questions[questionLabel].value,
        score: this.assessment.scoredResultsJson.riskSubSections[this.selectNistCategory].questions[questionLabel].score
      }
      return q;
    });
  }
}
